import styled from 'styled-components';

export const AddTaxTypeWrapper = styled.button`
    display: flex;
    padding: 7px 10px;
    background: #4eba55;
    color: #fff;
    border-radius: 5px; 
    cursor: pointer;
    outline: 0;
    border: none;
`;

export const AddTaxTypeSpan = styled.span`
    margin-left: auto;
    font-size: 16px;
    text-transform: uppercase;
    font-size: 14px;
`

export const NoResultsWrapper = styled.div`
    text-align: center;
    padding: 100px;
`;
